<template>
  <page-wrapper title="เพิ่มผู้ทดลองใช้">
    <confirm-dialog
      v-if="confirmSave.isShow"
      :data="confirmSave"
      @confirm="handleConfirmSave"
    />
    <div class="pt-4 add-trial-page">
      <div class="row">
        <div class="col-lg-2 col-sm-12">
          <p>ผู้ทดลองใช้</p>
          <el-select
            v-model="selectedUser"
            :remote-method="searchUser"
            :loading="loadingUser"
            class="w-100"
            value-key="user_id"
            filterable
            remote
          >
            <el-option
              v-for="item in searchUserResult"
              :key="item.id"
              :label="item.label"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-lg-2 col-sm-12">
          <p>บ้านที่ทดลองใช้</p>
          <el-select
            v-model="selectedHome"
            :remote-method="searchHome"
            :loading="loadingHome"
            value-key="homeId"
            class="w-100"
            filterable
            remote
          >
            <el-option
              v-for="(item, indexHome) in searchHomeResult"
              :key="indexHome"
              :label="item.label"
              :value="item"
              class="home-option"
            >
              <p class="title">{{ item.title }}</p>
              <p class="subtitle">{{ item.subtitle }}</p>
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-8 col-sm-12">
          <p>แพ็กเกจ</p>
          <el-select
            v-model="selectedPackage"
            :remote-method="handleRemoteMethod"
            value-key="id"
            class="w-100"
            filterable
            clearable
            remote
          >
            <el-option
              v-for="item in packages"
              :key="item.id"
              :label="item.name"
              :value="item"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-lg-2 col-sm-12">
          <div v-if="user" class="user-detail">
            <p>ชื่อ</p>
            <div class="mb-2">{{ user.firstName }}</div>
            <p>นามสกุล</p>
            <div class="mb-2">{{ user.lastName }}</div>
            <p>เพศ</p>
            <div class="mb-2">{{ user.gender }}</div>
            <p>วันเกิด</p>
            <div class="mb-2">{{ user.birthDate }}</div>
            <p>บัตรประชาชน / Passport</p>
            <div class="mb-2">{{ user.identifierId }}</div>
            <p>เบอร์โทรศัพท์</p>
            <div class="mb-2">{{ user.phoneNumber }}</div>
            <p>อีเมล</p>
            <div class="mb-2">{{ user.email }}</div>
            <p>สถานะ</p>
            <div class="mb-2">{{ user.status }}</div>
          </div>
        </div>
        <div class="col-lg-2 col-sm-12">
          <div v-if="home" class="home-detail">
            <p>บ้านเลขที่</p>
            <div class="mb-2">{{ home.addressNo }}</div>
            <p>โครงการ</p>
            <div class="mb-2">{{ home.projectName }}</div>
          </div>
        </div>
        <div class="col-lg-8 col-sm-12">
          <div v-if="pack">
            <div class="row mb-2">
              <div class="col-sm-12 col-lg-4">
                <img :src="pack.coverUrl" class="img-fluid d-block mb-2" />
              </div>
              <div class="col-sm-12 col-lg-8">
                <div class="mb-2">ชื่อ: {{ pack.name }}</div>
                <div class="mb-2">recurring: {{ pack.billingCycle }}</div>
              </div>
            </div>
            <service-option-offline-purchase
              v-model="packageOptionDetail"
              :data="pack"
            ></service-option-offline-purchase>
            <p class="mt-4">โครงการที่รองรับ</p>
            <div class="mb-2 project">
              <p v-for="(project, index) in pack.projects" :key="index">
                {{ project.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showUnsupportedAlert" class="text-end mt-4 text-danger">
        Package นี้ไม่รองรับโครงการของบ้านที่เลือก
      </div>
      <div class="mt-4 text-end">
        <sc-button
          :disabled="isLoading"
          variant="primary"
          @click="handleClickSave"
          >บันทึก</sc-button
        >
      </div>
      <div>
        <confirm-dialog v-show="isAddingHome" :data="addHomeConfirm">
          <add-home v-model="addHomeForm"></add-home>
          <div class="text-end">
            <sc-button class="me-2" @click="handleCancelAddHome"
              >ยกเลิก</sc-button
            >
            <sc-button variant="primary" @click="handleSaveAddHome"
              >บันทึก</sc-button
            >
          </div>
        </confirm-dialog>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import ConfirmDialog from "@/components/helper/dialog/ConfirmDialog";
import { baanRueJaiClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { toLocaleTH } from "@/lib/dateTime";
import {
  convertBathToStangAndRoundTwoDecimal,
  convertPriceStringToInt,
  convertStangToBathAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString
} from "@/lib/formatter";
import { genderMapper, userRoleMapper } from "@/lib/mapper";
import { toCamelCaseObject } from "@/lib/util";
import { Option, Select } from "element-ui";
import { DateTime } from "luxon";
import AddHome from "../../../../managements/modules/users/components/AddHome";
import ServiceOptionOfflinePurchase from "../components/ServiceOptionOfflinePurchase";

export default {
  components: {
    ConfirmDialog,
    PageWrapper,
    ScButton,
    "el-select": Select,
    "el-option": Option,
    ServiceOptionOfflinePurchase,
    AddHome
  },
  data() {
    const packageOptionDetail = {
      packageOptions: [],
      packagePrice: null,
      quality: 1,
      discountAmount: null,
      totalPrice: null,
      mainOptionSelected: [],
      extraOptionSelected: [],
      isWithholding: false,
      totalPriceWithholding: null
    };

    const addHomeForm = {
      project: null,
      homes: [],
      role: null
    };

    const addHomeConfirm = {
      title: "เพิ่มผู้ใช้เข้าบ้าน"
    };

    return {
      selectedUser: null,
      selectedHome: null,
      selectedPackage: null,
      loadingUser: false,
      searchUserResult: [],
      searchHomeResult: [],
      packages: [],
      packageDetail: null,
      packageOptionDetail,
      isLoading: false,
      filterHome: [],
      loadingHome: false,
      homeUniqueList: null,
      addHomeToUser: "addHomeToUser",
      addHomeForm,
      isAddingHome: false,
      addHomeConfirm,
      confirmSave: {
        isShow: false,
        title: 'ยืนยันการเพิ่มผู้ทดลองใช้',
        buttonSubmit: 'ยืนยัน',
        buttonCancel: 'ยกเลิก'
      }
    };
  },
  computed: {
    user() {
      if (this.selectedUser === null) {
        return null;
      }

      const user = this.selectedUser.user
        ? this.selectedUser.user
        : this.selectedUser;

      const { user_profile: userProfile, email } = user;
      const {
        first_name: firstName,
        last_name: lastName,
        gender: genderEnum,
        citizen_id: citizenId,
        passport_number: passportNumber,
        birth_date: birthDate,
        mobile_number: mobileNumber
      } = userProfile;
      const identifierId = citizenId || passportNumber || "-";
      const isVerified = identifierId !== "-";
      const gender = genderEnum ? genderMapper[genderEnum] : "-";
      const formattedBirthDate = birthDate
        ? toLocaleTH(DateTime.fromISO(birthDate)).toFormat("dd MMMM yyyy")
        : "-";
      const phoneNumber = mobileNumber || "-";
      const status = isVerified ? "ยืนยันตัวตนแล้ว" : "ยังไม่ยืนยันตัวตน";

      return {
        firstName,
        lastName,
        gender,
        birthDate: formattedBirthDate,
        identifierId,
        phoneNumber,
        status,
        isVerified,
        email
      };
    },
    home() {
      if (!this.selectedHome) {
        return null;
      }

      const {addressNo} = this.selectedHome;
      const projectName = `${this.selectedHome.projectName} (${this.selectedHome.projectCode})`;

      return {
        addressNo,
        projectName
      };
    },
    pack() {
      if (!this.selectedPackage) {
        return null;
      }

      const {name} = this.selectedPackage;
      const price =
        `${formatCurrencyAndTwoDecimalsString(this.selectedPackage.price / 100) 
        } บาท`;
      const billingCycle =
        `${this.selectedPackage.billing_cycle.toLocaleString()  } เดือน`;
      const coverUrl = this.selectedPackage.image_url;
      const pack = {
        name,
        price,
        billingCycle,
        coverUrl
      };

      if (!this.packageDetail) {
        return pack;
      }

      const services = this.packageDetail.services.map(service => {
        const {
          id,
          name: serviceName,
          short_description: shortDescription,
          description
        } = service;
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url
        };

        return {
          id,
          name: serviceName,
          shortDescription,
          description,
          provider,
          servicePrices: null,
          mainOption: null,
          extraOption: null
        };
      });

      const projects = this.packageDetail.projects.map(project => ({
          id: project.project_code,
          name: `${project.project_code} - ${project.project_name}`
        }));
      pack.services = services;
      pack.projects = projects;
      pack.packagePrice = convertBathToStangAndRoundTwoDecimal(
        this.selectedPackage.price
      );
      pack.packageId = this.selectedPackage.id;

      return pack;
    },
    showUnsupportedAlert() {
      return (
        this.selectedHome &&
        this.selectedPackage &&
        !this.selectedPackage.project_ids.includes(this.selectedHome.projectId)
      );
    }
  },
  watch: {
    async selectedUser(val) {
      if (val === null) {
        this.searchUserResult = [];
        this.homeId = null;
        return;
      }

      const userId = val.user ? val.user.user_id : val.user_id;

      await this.getUserDetail(userId);
    },
    async selectedHome(newValue) {
      if (
        newValue &&
        newValue.homeId &&
        newValue.homeId === this.addHomeToUser
      ) {
        this.isAddingHome = true;
        this.selectedHome = undefined;
      }

      if (!newValue) {
        this.searchHomeResult = [];
        this.userId = null;
        return;
      }

      const homeId = newValue.home ? newValue.home.homeId : newValue.homeId;
      const result = this.filterHome;

      const homeResult = result
        .filter(user => user.homes && user.homes.length)
        .flatMap(item => {
          const {user} = item;
          const {homes} = item;

          return homes.map(h => ({
              homeId: h.home_id,
              user
            }));
        });

      const homeUserResult = homeResult.filter(
        home => home.homeId === homeId && !home.user
      );
      if (homeUserResult.length === 0) {
        this.searchUserResult = [];
      }

      this.searchUserResult = homeResult
        .filter(home => home.homeId === homeId)
        .map(item => {
          const user = item.user ? item.user : item;

          return {
            ...user,
            label: `${user.user_profile.first_name} ${user.user_profile.last_name}`
          };
        });
    },
    async selectedPackage(val) {
      if (!val) return;

      const { id } = val;

      this.packageDetail = await this.fetchPackageDetail(id);

      let packageOptions = [];
      if (this.packageDetail.package_options) {
        packageOptions = this.packageDetail.package_options.map(
          (serviceOption, serviceOptionIndex) => {
            let serviceVariants;
            if (
              serviceOption.service_option_variants &&
              serviceOption.service_option_variants.length > 0
            ) {
              serviceVariants = serviceOption.service_option_variants.map(
                (serviceVariant, serviceVariantIndex) => {
                  const variants = serviceVariant.variants.map(variant => {
                    if (serviceVariantIndex === 0 && !variant.extra_option) {
                      this.packageOptionDetail.mainOptionSelected[
                        serviceOptionIndex
                      ] = {
                        isExtraOption: variant.extra_option,
                        price:
                          variant.price !== null
                            ? convertBathToStangAndRoundTwoDecimal(
                                variant.price
                              )
                            : null,
                        title: variant.title,
                        id: variant.id,
                        isNotSale: variant.isNotSale,
                        serviceId: serviceOption.service_id
                      };
                    }

                    return {
                      isExtraOption: variant.extra_option,
                      price:
                        variant.price !== null
                          ? convertBathToStangAndRoundTwoDecimal(
                              variant.price
                            )
                          : null,
                      title: variant.title,
                      id: variant.id,
                      isVariantSelected:
                        serviceVariantIndex === 0 && !variant.extra_option,
                      isNotSale: variant.is_not_sale
                    };
                  });

                  return {
                    title: serviceVariant.title,
                    id: serviceVariant.id,
                    variants
                  };
                }
              );
            }

            return {
              serviceTitle: serviceOption.service_title,
              serviceId: serviceOption.service_id,
              isNotSale: serviceOption.is_not_sale,
              servicePrice:
                serviceOption.service_price !== null
                  ? convertBathToStangAndRoundTwoDecimal(
                      serviceOption.service_price
                    )
                  : null,
              serviceVariants
            };
          }
        );
      }

      this.packageOptionDetail = {
        ...this.packageOptionDetail,
        packageOptions,
        isWithholding: null,
        totalPriceWithholding: null
      };
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupPackages();
    },
    async setupPackages() {
      const result = await this.fetchPackages();

      this.packages = result;
    },
    async searchUser(query) {
      this.loadingUser = true;

      const [firstName, lastName, ...rest] = query.split(" ");
      const params = {
        firstName: firstName.trim(),
        lastName: lastName
          ? (`${lastName  } ${  rest.join(" ")}`).trim()
          : undefined
      };

      const result = await this.fetchUser(params);

      this.searchUserResult = result.users.map(item => {
        const user = item.user ? item.user : item;

        return {
          ...user,
          label: `${user.user_profile.first_name} ${user.user_profile.last_name}`
        };
      });

      this.loadingUser = false;
    },
    async searchHome(queryString) {
      this.loadingHome = true;
      const query = {
        text_search: "",
        project_home_search: queryString,
        take: 30,
        is_filter_without_deleted_user_home: true,
        user_id:
          this.selectedUser && this.selectedUser.user_id
            ? +this.selectedUser.user_id
            : undefined
      };

      const response = await baanRueJaiClient.admin.users.search(query);

      const {users} = response.data.result;
      const search = users
        .filter(user => user.homes && user.homes.length > 0)
        .flat();

      const homesSearchList = search.flatMap(item => {
        const {homes} = item;

        return homes
          .filter(home => home.address_no !== "")
          .map(h => {
            const camelCaseHome = toCamelCaseObject(h);
            const { addressNo, projectCode, projectName } = camelCaseHome;
            const title = `บ้านเลขที่ ${addressNo}`;
            const subtitle = `${projectCode} ${projectName}`;
            const label = `${title} (${projectCode})`;

            return {
              ...camelCaseHome,
              title,
              subtitle,
              label
            };
          });
      });
      const homeUniqueList = homesSearchList
        ? this.getUniqueListBy(homesSearchList, "homeId")
        : null;
      this.filterHome = search;
      this.searchHomeResult = homeUniqueList;
      this.loadingHome = false;
    },
    async fetchUser(query) {
      const response = await baanRueJaiClient.admin.users.list(query);

      return response.data.result;
    },
    async fetchUserDetail(userId) {
      const response = await baanRueJaiClient.admin.users.get(userId);

      return response.data.result;
    },
    async fetchPackages() {
      const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.list(
        { filterlifestyle: false }
      );

      return response.data.result.packages;
    },
    async fetchPackageDetail(id) {
      const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.get(
        id
      );

      return response.data.result;
    },
    async handleRemoteMethod(queryString) {
      // หาครั้งแรกว่ามีอีกกี่ package
      const firstPackagePage = await baanRueJaiClient.admin.subscriptions.recommend_packages.list(
        {
          name: queryString,
          filterlifestyle: false,
          page: 1
        }
      );
      const responseFirstPackage = firstPackagePage.data.result.packages;
      this.packages = responseFirstPackage;

      const responseFirstPackageCount = firstPackagePage.data.result.count;

      const countLeftPackage =
        responseFirstPackageCount && +responseFirstPackageCount > 10
          ? +responseFirstPackageCount - 10
          : undefined;

      if (countLeftPackage && queryString) {
        const limitTake =
          countLeftPackage && countLeftPackage > 60 ? 60 : countLeftPackage;

        const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.list(
          {
            name: queryString,
            filterlifestyle: false,
            page: 2,
            take: limitTake
          }
        );
        const responseLeftPackages = response.data.result.packages;

        const allPackages = this.packages.concat(responseLeftPackages);
        this.packages = allPackages;
      }
    },
    checkExistValueToAlertMassage(value, massageToAlert) {
      const massage = massageToAlert || "ไม่สามารถบันทึกข้อมูลได้";
      if (!value || value.length === 0) {
        this.$message.error(massage);
        this.isLoading = false;
        return false;
      } 
        return true;
    },
    handleClickSave() {
      this.confirmSave.isShow = true;
    },
    handleConfirmSave(confirmed) {
      this.confirmSave.isShow = false;
      if (confirmed) this.executeSave();
    },
    async executeSave() {
      this.isLoading = true;

      if (!this.selectedUser) {
        this.$message.error("กรุณาเลือก ผู้ใช้");
        this.isLoading = false;
        return;
      }

      if (
        !this.checkExistValueToAlertMassage(
          this.selectedUser.user_id,
          "กรุณาเลือก ผู้ใช้"
        )
      )
        return;

      if (
        !this.checkExistValueToAlertMassage(
          this.selectedHome.homeId,
          "กรุณาเลือก บ้านเลขที่"
        )
      )
        return;

      if (
        !this.checkExistValueToAlertMassage(
          this.selectedPackage.id,
          "กรุณาเลือก แพ็กเกจ"
        )
      )
        return;

      if (
        !this.checkExistValueToAlertMassage(
          this.packageOptionDetail.quality,
          "กรุณาเลือก จำนวนการซื้อแพ็คเกจ"
        )
      )
        return;

      const packagePriceDetail = {};
      packagePriceDetail.quantity = +this.packageOptionDetail.quality;
      packagePriceDetail.price = convertPriceStringToInt(
        this.packageOptionDetail.packagePrice
      );

      packagePriceDetail.services = this.packageOptionDetail.packageOptions.map(
        serviceOption => {
          const mainOptionSelected =
            this.packageOptionDetail.mainOptionSelected.find(
              item => item && item.serviceId === serviceOption.serviceId
            ) || null;

          const extraOptionSelected =
            this.packageOptionDetail.extraOptionSelected.filter(
              item => item && item.serviceId === serviceOption.serviceId
            ) || null;

          let mainOption = {};
          mainOption.price =
            mainOptionSelected &&
            mainOptionSelected.price !== null &&
            mainOptionSelected.price >= 0
              ? convertStangToBathAndRoundTwoDecimal(
                  +mainOptionSelected.price
                )
              : null;
          mainOption.variant_id = mainOptionSelected && mainOptionSelected.id;
          mainOption.extra_option =
            mainOptionSelected &&
            extraOptionSelected.map(varaint => ({
                variant_id: varaint.id,
                price: convertStangToBathAndRoundTwoDecimal(
                  varaint.price
                )
              }));

          if (!mainOptionSelected) {
            mainOption = null;
          }

          let sumOptionPrice;
          if (mainOption && mainOption.price) {
            sumOptionPrice = convertBathToStangAndRoundTwoDecimal(
              +mainOption.price
            );
            if (mainOption.extra_option) {
              const extraPrice = mainOption.extra_option.reduce(
                (a, b) => a + b.price,
                0
              );
              sumOptionPrice += convertBathToStangAndRoundTwoDecimal(
                extraPrice
              );
            }
          }
          const price = sumOptionPrice || serviceOption.servicePrice;

          return {
            service_id: serviceOption.serviceId,
            price: convertPriceStringToInt(price),
            main_option: mainOption
          };
        }
      );

      const packageId = this.selectedPackage.id;
      const {homeId} = this.selectedHome;
      const {projectId} = this.selectedHome;
      const userId = this.selectedUser.user_id;

      const params = {
        packageId,
        homeId,
        projectId,
        userId,
        packagePriceDetail
      };
      try {
        await baanRueJaiClient.admin.subscriptions.subscribers.postFreeTrialAdd(params);
        this.$router.push({ name: "SubscriberListPage" });
      } catch (error) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง");
        this.isLoading = false;
      }
    },
    handleCancelAddHome() {
      this.isAddingHome = false;

      this.addHomeForm = {
        project: null,
        homes: [],
        role: null
      };
    },
    async handleSaveAddHome() {
      this.isAddingHome = false;

      try {
        await this.inviteUserToHome();
      } catch (error) {
        this.$message.error("ไม่สามารถเพิ่มผู้ใช้เข้าบ้านได้");
      }

      this.addHomeForm = { homes: [], project: null, role: null };
    },
    async inviteUserToHome() {
      const { project, homes, role } = this.addHomeForm;
      if (!project) {
        this.$message.error("กรุณาเลือกโครงการ");
        return;
      }
      const homeIds = homes.map(({ homeId }) => homeId);
      const { projectId } = project;
      const params = {
        homeIds,
        projectId,
        role
      };

      await baanRueJaiClient.admin.users.invite(
        this.selectedUser.user_id,
        params
      );
      await this.getUserDetail(this.selectedUser.user_id);
    },
    async getUserDetail(userId) {
      const result = await this.fetchUserDetail(userId);

      const addHomeToUser = [
        {
          title: "+ เพิ่มลูกค้าเข้าบ้าน",
          homeId: this.addHomeToUser,
          label: undefined,
          subtitle: undefined
        }
      ];

      if (!result.homes) {
        this.searchHomeResult = addHomeToUser;
        return;
      }

      const searchHomeDetail = result.homes
      .filter((home) => home.address_no !== "")
      .map((home) => {
          const camelCaseHome = toCamelCaseObject(home);
          const { addressNo, projectCode, projectName, userRole } = camelCaseHome;
          const userRoleTH = userRoleMapper[userRole];
          const title = `${userRoleTH} บ้านเลขที่ ${addressNo}`;
          const subtitle = `${projectCode} ${projectName}`;
          const label = `${title} (${projectCode})`;

          return {
            ...camelCaseHome,
            title,
            subtitle,
            label
          };
      });

      this.searchHomeResult = addHomeToUser.concat(searchHomeDetail);
    },
    getUniqueListBy(array, key) {
      return [...new Map(array.map(item => [item[key], item])).values()];
    }
  }
};
</script>

<style lang="scss" scoped>
.home-option {
  padding-top: 10px;
  padding-bottom: 10px;
  height: auto;

  > .title,
  > .subtitle {
    margin: 0;
  }

  > .title {
    font-size: 14px;
    font-weight: normal;
  }

  > .subtitle {
    font-size: 12px;
  }
}
.add-trial-page {
  padding-left: 10px;
  padding-right: 10px;
}

.project {
  width: auto;
  height: 400px;
  overflow-x: auto;
}
</style>
